export const kitData = [
  {
    name: 'Estee Lauder Revitalizing Set',
    shortDescription: 'Starter Kit Gift Set',
    description: 'Dewy primer with instant 3X moisture.',
    image: '/images/Kit/Group 1066.png',
    price: '70',
  },
  {
    name: 'Estee Lauder Re-Nutriv Moisture Skincare Set',
    shortDescription: 'Skincare Gift Set',
    description: 'Reveal a remarkably more lifted, firmer look.',
    image: '/images/Kit/Group 1067.png',
    price: '250',
  },
  {
    name: 'Cedar Violet Gift Set',
    shortDescription: '3-piece Gift Set',
    description: "Amber Collection brings together two of AERIN's signature scents.",
    image: '/images/Kit/Group 1068.png',
    price: '180',
  },
  {
    name: 'Pure Color Envy Lipstick Wonders',
    shortDescription: 'Set of 5 lipsticks',
    description: 'Limited EDITION Lipstick SET Pure Color Envy.',
    image: '/images/Kit/Group 1077.png',
    price: '55',
  },
  {
    name: 'Estee Lauder Glow Non-Stop 24/7 Radiant Skincare',
    shortDescription: '50ML - Skincare Set',
    description: 'Skin to feel firmer, look radiant, deeply nourished.',
    image: '/images/Kit/Group 1074.png',
    price: '120',
  },
  {
    name: 'Estee Lauder Winter Makeup Set',
    shortDescription: 'Makeup Essentials for everyday',
    description: 'Dewy, glowy for the perfect everyday makeup look.',
    image: '/images/Kit/Group 1078.png',
    price: '150',
  },
  {
    name: 'Pure Color Envy Lipstick Wonders',
    shortDescription: 'Set of 5 lipsticks',
    description: 'Limited EDITION Lipstick SET Pure Color Envy',
    image: '/images/Kit/Group 1072.png',
    price: '55',
  },
  {
    name: 'Beautiful Magnolia Romantic Dreams Gift Set',
    shortDescription: 'A hypnotic blend with signature notes',
    description: 'A gift set containing a feminine fragrance.',
    image: '/images/Kit/Group 1073.png',
    price: '200',
  },
  {
    name: 'Double Wear Makeup Kit',
    shortDescription: 'Create a sheer, natural look that stays all day',
    description: 'Special purchase available while supplies last.',
    image: '/images/Kit/Group 1083.png',
    price: '45',
  },
]